import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { FragmentsListV3Page } from '../screens/list-v3/FragmentsListV3Page';

export function FragmentsListStationPage() {
  return (
    <StationPageWrapper>
      <FragmentsListV3Page />
    </StationPageWrapper>
  );
}
